<template>
  <div class="notepad-container">
    <!-- NotepadComponent -->
    <iframe src="https://oschip.cloud:9006" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: "NotepadComponent",
  data() {
    return {};
  },
  mounted() {},
  computed: {},
};
</script>

<style lang="scss">
.notepad-container {
  height: 100%;
}
</style>
